import {DeviceCard} from '../../deviceCard';
import {DevicesCardsWrapper, IntroText} from './styles.ts';
import {useState} from 'react';
import {DeviceInfoModal} from '../../deviceInfoModal';
import {CARDS, DeviceCardData} from 'widgets/devicesInfo/consts/cards.consts.ts';

export const DevicesInfo = () => {
  const [currentDevice, setCurrentDevice] = useState<DeviceCardData>();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpen = (card: DeviceCardData) => {
    setCurrentDevice(card);
    setIsModalOpen(true);
  };

  const handleClose = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <IntroText>
        {`Цифровой улей - система мониторинга жизнедеятельности пчел в улье.
        Собирает данные о температуре, влажности, СО2, массе (привес), звуке (жужжание пчел). Система позволяет контролировать состояние пчел в улье, своевременно проводить различные работы в улье, изучать удивительный мир пчел.`}
      </IntroText>

      <DevicesCardsWrapper>
        {CARDS.map((card) => (
          <DeviceCard card={card} handleOpenModal={handleOpen} img={card.img} />
        ))}
      </DevicesCardsWrapper>
      <DeviceInfoModal open={isModalOpen} onClose={handleClose} device={currentDevice} />
    </>
  );
};
